import "./App.css";
import TopButtons from "./components/TopButtons";
import Inputs from "./components/Inputs";
import TimeAndLocation from "./components/TimeAndLocation";
import Forecast from "./components/Forecast";
import getFormattedWeatherData from "./services/weatherService";
import { useEffect, useState } from "react";
import TemperatureAndDetails from "./components/TempratureAndDetails";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [query, setQuery] = useState({ q: "mohali" });
  const [units, setUnits] = useState("metric");
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      const message = query.q ? query.q : "current location.";

      toast.info("Fetching weather for " + message);

      await getFormattedWeatherData({ ...query, units }).then((data) => {
        toast.success(
          `Successfully fetched weather for ${data.name}, ${data.country}.`
        );

        setWeather(data);
      });
    };

    fetchWeather();
  }, [query, units]);

  const formatBackground = () => {
    if (!weather) return "from-violet-900 to-purple-300";
    const threshold = units === "metric" ? 20 : 60;
    if (weather.temp <= threshold) return "from-violet-900 to-purple-300";

    return "from-yellow-400 to-orange-600";
  };

  return (
    <div
      className={`mx-auto  py-5 px-32 bg-gradient-to-br  h-fit shadow-xl shadow-gray-400 ${formatBackground()}`}
    >
        <TopButtons setQuery={setQuery} />
        <Inputs setQuery={setQuery} units={units} setUnits={setUnits} />
      {weather && (
        <div>
          <TimeAndLocation weather={weather} />
          <TemperatureAndDetails weather={weather} />

          <Forecast title="hourly forecast" items={weather.hourly} />
          <Forecast title="daily forecast" items={weather.daily} />
        </div>
      )}
     
    
      

      

      <ToastContainer autoClose={5000} theme="colored" newestOnTop={true} />
    </div>
  );
}

export default App;

// import './App.css';
// import UilReact from '@iconscout/react-unicons/icons/uil-react'
// import TopButtons from './components/TopButtons';
// import Inputs from './components/Inputs';
// import TimeAndLocation from './components/TimeAndLocation';
// import TempratureAndDetails from './components/TempratureAndDetails';
// import Forecast from './components/Forecast';


// function App() {
//   return (
//     <div className="mx-auto max-w-screen-md mt-4 py-5 px-32 bg-gradient-to-br from-cyan-500 to-blue-800 h-fit shadow-xl shadow-gray-400">
//      <TopButtons/>
//      <Inputs/>

//      <TimeAndLocation/>
//      <TempratureAndDetails/>
//      <Forecast title="hourly forecast"/>
//      <Forecast title="Daily forecast"/>
//     </div>
//   );
// }

// export default App;
